import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IAgreementDocumentVm } from '../agreement-document-vm.model';
import { IMyOskAgreementPreviewIm } from '../my-osk-agreement-preview-im.model';
@Injectable({ providedIn: 'root' })
export class MyOskAgreementPreviewService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskAgreementPreview`;
  }
  post(myOskAgreementPreviewIm: IMyOskAgreementPreviewIm): Observable<IAgreementDocumentVm> {
    const headers = this.createHeaders();
    return this.http.post<IAgreementDocumentVm>(this.baseUrl, myOskAgreementPreviewIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
